import _ from './toolbar-notifications.module.scss'
import React, {useEffect, useState} from 'react'
import {useHideAwarePosition} from '../../../../hooks/use-hide-aware-position'
import {$, $$$} from '../../../../shared/class-name'
import {useNotificationSummary} from '../../hooks/use-notification-summary'
import {useIs1024} from '../../../../hooks/use-is-1024'
import {NotificationBadges} from './notification-badges'

export const ToolbarNotifications = ({
    rootElementRef, containerName, floatingPosition, isHidden, hasContent, floating, top,
    fadingOut: externalFadingOut,
}) => {
    const [rootWidth, setRootWidth] = useState(rootElementRef?.offsetWidth)
    const {notifSummary, fadingOut: internalFadingOut} = useNotificationSummary()
    const fadingOut = externalFadingOut || internalFadingOut
    const {position, hidden, noTransition} = useHideAwarePosition(floatingPosition, isHidden, hasContent)
    const is1024 = useIs1024()

    useEffect(() => {
        const el = rootElementRef?.current
        if (!el) return
        const observer = new ResizeObserver(() => setRootWidth(el.offsetWidth))
        observer.observe(el)
        setRootWidth(el.offsetWidth)
        return () => observer.disconnect()
    }, [rootElementRef])

    if (!notifSummary || notifSummary.total <= 0) return null

    return <div style={rootWidth ? {width: rootWidth} : undefined} className={$$$(
        $(_.root),
        $(_.hidden, hidden && !is1024),
        $(_.noTransition, noTransition),
        $(_.floating, floating),
        $(_.top, top),
        $(_.left, position === 'left'),
        $(_.right, position === 'right'),
    )}><div className={_.badges}>
        <NotificationBadges notifSummary={notifSummary} fadingOut={fadingOut} containerName={containerName}/>
    </div></div>
}
